import { render, staticRenderFns } from "./CbsConstructor.vue?vue&type=template&id=156b3831&scoped=true"
import script from "./CbsConstructor.vue?vue&type=script&lang=js"
export * from "./CbsConstructor.vue?vue&type=script&lang=js"
import style0 from "./CbsConstructor.vue?vue&type=style&index=0&id=156b3831&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156b3831",
  null
  
)

export default component.exports